export default "__VITE_ASSET__BaKGPBXw__"